export const PERMISSION = {
    DEFAULT: 'default',
    GRANTED: 'granted',
    DENIED: 'denied',
};
